export default "__VITE_ASSET__4e8e62e1__"